import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createTheme, MantineProvider } from '@mantine/core';
import ProtectedRoute from './components/ProtectedRoutes/page';
import Login from './components/Login/page';
import Home from './components/Home/page';
import Conciliaciones from './components/Conciliaciones/page';
import Reportes from './components/Reportes/page';
import ReportesRDI from './components/ReportesRDI/page';
import CifrasRDI from './components/CifrasRDI/page';



import ErrorPage from './components/ErrorPage/page';
import AppContextProvider from './context/context';
import { Notifications } from '@mantine/notifications'; // Import from @mantine/notifications
import '@mantine/notifications/styles.css';
import './App.css';

const theme = createTheme({
});

function App() {
  return (
    <MantineProvider theme={theme} withCSSVariables>
      <Notifications position="top-right" zIndex={999} />
      <AppContextProvider>
        <BrowserRouter>          
            <Routes>
              <Route path='/' element={<Login />}> </Route>
              
              <Route element={<ProtectedRoute />}>
                <Route path="/Home" element={<Home />} />
                <Route path="/Conciliaciones" element={<Conciliaciones />} />
                <Route path="/Reportes" element={<Reportes />} />
                <Route path="/ReportesRDI" element={<ReportesRDI />} />
                <Route path='/CifrasRDI' element={<CifrasRDI />}/>             
              </Route>
              <Route path='*' element={<ErrorPage/>}></Route>
            </Routes>          
        </BrowserRouter>
      </AppContextProvider>

    </MantineProvider>
  );
}

export default App;
